// Card endpoints live on the dataProvider (getCardAssignees, updateCardStatus,
// createCardComment, …). This module keeps only the shared error parser they use.

export function parseError(data: unknown, fallback: string): string {
    if (!data || typeof data !== 'object') return fallback;

    // Backend wraps errors as {"errors": <detail>} (HTTPReactException) or {"detail": …}
    // (plain HTTPException); unwrap before looking for the message.
    const wrapper = data as Record<string, unknown>;
    if (typeof wrapper.detail === 'string') return wrapper.detail;
    const unwrapped = wrapper.errors ?? wrapper;
    if (!unwrapped || typeof unwrapped !== 'object') return fallback;
    const obj = unwrapped as Record<string, unknown>;

    // Try "root.serverError" (auth/validation errors)
    if (obj.root && typeof obj.root === 'object') {
        const root = obj.root as Record<string, unknown>;
        if (typeof root.serverError === 'string') return root.serverError;
    }

    // Try first field error
    const entries = Object.entries(obj);
    if (entries.length > 0 && typeof entries[0][1] === 'string') {
        return entries[0][1] as string;
    }

    return fallback;
}
